import { useCallback } from 'react';

import type { OrderAppCheckoutLineInput } from '@/graphql/orderApp/api';

import type { AllSelectedProducts } from './useAllSelectedProductsState';
import { useCheckout } from './useCheckout';

export const useAddToBagFromModal = (
  allSelectedProducts: AllSelectedProducts,
  watchLineId?: string,
) => {
  const { linesAdd } = useCheckout();

  const addToBagFromModal = useCallback(async () => {
    const selectedBuckle = allSelectedProducts.products.find(
      (product) => product.productTypeSlug === 'buckle',
    );
    // preOrder can't add strap or buckle so all metadata add from modal should be 'ORDER'
    const metadata = [
      {
        key: 'item.cta_selected',
        value: 'ORDER',
      },
    ];

    if (selectedBuckle) {
      // Buckle must be always added together with strap as "strapRelatedProducts"
      // "watchLineId" must be provided when strap is added to watch.
      const productList = allSelectedProducts.products.filter(
        (product) => product.id !== selectedBuckle.id,
      );

      await linesAdd(
        productList.map((product) => {
          if (product.productTypeSlug === 'strap') {
            return {
              variantId: product.id,
              strapRelatedProducts: { buckleId: selectedBuckle.id },
              metadata,
              ...{ ...(watchLineId && { watchLineId }) },
            } satisfies OrderAppCheckoutLineInput;
          } else {
            return {
              variantId: product.id,
              metadata,
            } satisfies OrderAppCheckoutLineInput;
          }
        }),
      );
    } else {
      await linesAdd(
        allSelectedProducts.products.map((product) => {
          if (product.productTypeSlug === 'strap') {
            return {
              variantId: product.id,
              metadata,
              ...{ ...(watchLineId && { watchLineId }) },
            } satisfies OrderAppCheckoutLineInput;
          } else {
            return {
              variantId: product.id,
              metadata,
            } satisfies OrderAppCheckoutLineInput;
          }
        }),
      );
    }
  }, [allSelectedProducts, watchLineId]);

  return { addToBagFromModal };
};
